/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OrdenarRouteImport } from './routes/ordenar'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppConfiguracionPedidosRouteImport } from './routes/_app/configuracion-pedidos'
import { Route as AppReportesIndexRouteImport } from './routes/_app/reportes/index'
import { Route as AppPedidosIndexRouteImport } from './routes/_app/pedidos/index'
import { Route as AppInventarioIndexRouteImport } from './routes/_app/inventario/index'
import { Route as AppGastosIndexRouteImport } from './routes/_app/gastos/index'
import { Route as AppExportarIndexRouteImport } from './routes/_app/exportar/index'
import { Route as AppCalendarioIndexRouteImport } from './routes/_app/calendario/index'
import { Route as AppPedidosNuevoRouteImport } from './routes/_app/pedidos/nuevo'
import { Route as AppPedidosPedidoIdRouteImport } from './routes/_app/pedidos/$pedidoId'
import { Route as AppGastosNuevoRouteImport } from './routes/_app/gastos/nuevo'
import { Route as AppGastosGastoIdRouteImport } from './routes/_app/gastos/$gastoId'
import { Route as AppCalendarioNuevoRouteImport } from './routes/_app/calendario/nuevo'
import { Route as AppCalendarioEventoIdRouteImport } from './routes/_app/calendario/$eventoId'

const OrdenarRoute = OrdenarRouteImport.update({
  id: '/ordenar',
  path: '/ordenar',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracionPedidosRoute = AppConfiguracionPedidosRouteImport.update({
  id: '/configuracion-pedidos',
  path: '/configuracion-pedidos',
  getParentRoute: () => AppRoute,
} as any)
const AppReportesIndexRoute = AppReportesIndexRouteImport.update({
  id: '/reportes/',
  path: '/reportes/',
  getParentRoute: () => AppRoute,
} as any)
const AppPedidosIndexRoute = AppPedidosIndexRouteImport.update({
  id: '/pedidos/',
  path: '/pedidos/',
  getParentRoute: () => AppRoute,
} as any)
const AppInventarioIndexRoute = AppInventarioIndexRouteImport.update({
  id: '/inventario/',
  path: '/inventario/',
  getParentRoute: () => AppRoute,
} as any)
const AppGastosIndexRoute = AppGastosIndexRouteImport.update({
  id: '/gastos/',
  path: '/gastos/',
  getParentRoute: () => AppRoute,
} as any)
const AppExportarIndexRoute = AppExportarIndexRouteImport.update({
  id: '/exportar/',
  path: '/exportar/',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarioIndexRoute = AppCalendarioIndexRouteImport.update({
  id: '/calendario/',
  path: '/calendario/',
  getParentRoute: () => AppRoute,
} as any)
const AppPedidosNuevoRoute = AppPedidosNuevoRouteImport.update({
  id: '/pedidos/nuevo',
  path: '/pedidos/nuevo',
  getParentRoute: () => AppRoute,
} as any)
const AppPedidosPedidoIdRoute = AppPedidosPedidoIdRouteImport.update({
  id: '/pedidos/$pedidoId',
  path: '/pedidos/$pedidoId',
  getParentRoute: () => AppRoute,
} as any)
const AppGastosNuevoRoute = AppGastosNuevoRouteImport.update({
  id: '/gastos/nuevo',
  path: '/gastos/nuevo',
  getParentRoute: () => AppRoute,
} as any)
const AppGastosGastoIdRoute = AppGastosGastoIdRouteImport.update({
  id: '/gastos/$gastoId',
  path: '/gastos/$gastoId',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarioNuevoRoute = AppCalendarioNuevoRouteImport.update({
  id: '/calendario/nuevo',
  path: '/calendario/nuevo',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarioEventoIdRoute = AppCalendarioEventoIdRouteImport.update({
  id: '/calendario/$eventoId',
  path: '/calendario/$eventoId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/ordenar': typeof OrdenarRoute
  '/configuracion-pedidos': typeof AppConfiguracionPedidosRoute
  '/calendario/$eventoId': typeof AppCalendarioEventoIdRoute
  '/calendario/nuevo': typeof AppCalendarioNuevoRoute
  '/gastos/$gastoId': typeof AppGastosGastoIdRoute
  '/gastos/nuevo': typeof AppGastosNuevoRoute
  '/pedidos/$pedidoId': typeof AppPedidosPedidoIdRoute
  '/pedidos/nuevo': typeof AppPedidosNuevoRoute
  '/calendario/': typeof AppCalendarioIndexRoute
  '/exportar/': typeof AppExportarIndexRoute
  '/gastos/': typeof AppGastosIndexRoute
  '/inventario/': typeof AppInventarioIndexRoute
  '/pedidos/': typeof AppPedidosIndexRoute
  '/reportes/': typeof AppReportesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/ordenar': typeof OrdenarRoute
  '/configuracion-pedidos': typeof AppConfiguracionPedidosRoute
  '/': typeof AppIndexRoute
  '/calendario/$eventoId': typeof AppCalendarioEventoIdRoute
  '/calendario/nuevo': typeof AppCalendarioNuevoRoute
  '/gastos/$gastoId': typeof AppGastosGastoIdRoute
  '/gastos/nuevo': typeof AppGastosNuevoRoute
  '/pedidos/$pedidoId': typeof AppPedidosPedidoIdRoute
  '/pedidos/nuevo': typeof AppPedidosNuevoRoute
  '/calendario': typeof AppCalendarioIndexRoute
  '/exportar': typeof AppExportarIndexRoute
  '/gastos': typeof AppGastosIndexRoute
  '/inventario': typeof AppInventarioIndexRoute
  '/pedidos': typeof AppPedidosIndexRoute
  '/reportes': typeof AppReportesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/ordenar': typeof OrdenarRoute
  '/_app/configuracion-pedidos': typeof AppConfiguracionPedidosRoute
  '/_app/': typeof AppIndexRoute
  '/_app/calendario/$eventoId': typeof AppCalendarioEventoIdRoute
  '/_app/calendario/nuevo': typeof AppCalendarioNuevoRoute
  '/_app/gastos/$gastoId': typeof AppGastosGastoIdRoute
  '/_app/gastos/nuevo': typeof AppGastosNuevoRoute
  '/_app/pedidos/$pedidoId': typeof AppPedidosPedidoIdRoute
  '/_app/pedidos/nuevo': typeof AppPedidosNuevoRoute
  '/_app/calendario/': typeof AppCalendarioIndexRoute
  '/_app/exportar/': typeof AppExportarIndexRoute
  '/_app/gastos/': typeof AppGastosIndexRoute
  '/_app/inventario/': typeof AppInventarioIndexRoute
  '/_app/pedidos/': typeof AppPedidosIndexRoute
  '/_app/reportes/': typeof AppReportesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/ordenar'
    | '/configuracion-pedidos'
    | '/calendario/$eventoId'
    | '/calendario/nuevo'
    | '/gastos/$gastoId'
    | '/gastos/nuevo'
    | '/pedidos/$pedidoId'
    | '/pedidos/nuevo'
    | '/calendario/'
    | '/exportar/'
    | '/gastos/'
    | '/inventario/'
    | '/pedidos/'
    | '/reportes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/ordenar'
    | '/configuracion-pedidos'
    | '/'
    | '/calendario/$eventoId'
    | '/calendario/nuevo'
    | '/gastos/$gastoId'
    | '/gastos/nuevo'
    | '/pedidos/$pedidoId'
    | '/pedidos/nuevo'
    | '/calendario'
    | '/exportar'
    | '/gastos'
    | '/inventario'
    | '/pedidos'
    | '/reportes'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/ordenar'
    | '/_app/configuracion-pedidos'
    | '/_app/'
    | '/_app/calendario/$eventoId'
    | '/_app/calendario/nuevo'
    | '/_app/gastos/$gastoId'
    | '/_app/gastos/nuevo'
    | '/_app/pedidos/$pedidoId'
    | '/_app/pedidos/nuevo'
    | '/_app/calendario/'
    | '/_app/exportar/'
    | '/_app/gastos/'
    | '/_app/inventario/'
    | '/_app/pedidos/'
    | '/_app/reportes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  OrdenarRoute: typeof OrdenarRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ordenar': {
      id: '/ordenar'
      path: '/ordenar'
      fullPath: '/ordenar'
      preLoaderRoute: typeof OrdenarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracion-pedidos': {
      id: '/_app/configuracion-pedidos'
      path: '/configuracion-pedidos'
      fullPath: '/configuracion-pedidos'
      preLoaderRoute: typeof AppConfiguracionPedidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reportes/': {
      id: '/_app/reportes/'
      path: '/reportes'
      fullPath: '/reportes/'
      preLoaderRoute: typeof AppReportesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pedidos/': {
      id: '/_app/pedidos/'
      path: '/pedidos'
      fullPath: '/pedidos/'
      preLoaderRoute: typeof AppPedidosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventario/': {
      id: '/_app/inventario/'
      path: '/inventario'
      fullPath: '/inventario/'
      preLoaderRoute: typeof AppInventarioIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gastos/': {
      id: '/_app/gastos/'
      path: '/gastos'
      fullPath: '/gastos/'
      preLoaderRoute: typeof AppGastosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exportar/': {
      id: '/_app/exportar/'
      path: '/exportar'
      fullPath: '/exportar/'
      preLoaderRoute: typeof AppExportarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendario/': {
      id: '/_app/calendario/'
      path: '/calendario'
      fullPath: '/calendario/'
      preLoaderRoute: typeof AppCalendarioIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pedidos/nuevo': {
      id: '/_app/pedidos/nuevo'
      path: '/pedidos/nuevo'
      fullPath: '/pedidos/nuevo'
      preLoaderRoute: typeof AppPedidosNuevoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pedidos/$pedidoId': {
      id: '/_app/pedidos/$pedidoId'
      path: '/pedidos/$pedidoId'
      fullPath: '/pedidos/$pedidoId'
      preLoaderRoute: typeof AppPedidosPedidoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gastos/nuevo': {
      id: '/_app/gastos/nuevo'
      path: '/gastos/nuevo'
      fullPath: '/gastos/nuevo'
      preLoaderRoute: typeof AppGastosNuevoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gastos/$gastoId': {
      id: '/_app/gastos/$gastoId'
      path: '/gastos/$gastoId'
      fullPath: '/gastos/$gastoId'
      preLoaderRoute: typeof AppGastosGastoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendario/nuevo': {
      id: '/_app/calendario/nuevo'
      path: '/calendario/nuevo'
      fullPath: '/calendario/nuevo'
      preLoaderRoute: typeof AppCalendarioNuevoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendario/$eventoId': {
      id: '/_app/calendario/$eventoId'
      path: '/calendario/$eventoId'
      fullPath: '/calendario/$eventoId'
      preLoaderRoute: typeof AppCalendarioEventoIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppConfiguracionPedidosRoute: typeof AppConfiguracionPedidosRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCalendarioEventoIdRoute: typeof AppCalendarioEventoIdRoute
  AppCalendarioNuevoRoute: typeof AppCalendarioNuevoRoute
  AppGastosGastoIdRoute: typeof AppGastosGastoIdRoute
  AppGastosNuevoRoute: typeof AppGastosNuevoRoute
  AppPedidosPedidoIdRoute: typeof AppPedidosPedidoIdRoute
  AppPedidosNuevoRoute: typeof AppPedidosNuevoRoute
  AppCalendarioIndexRoute: typeof AppCalendarioIndexRoute
  AppExportarIndexRoute: typeof AppExportarIndexRoute
  AppGastosIndexRoute: typeof AppGastosIndexRoute
  AppInventarioIndexRoute: typeof AppInventarioIndexRoute
  AppPedidosIndexRoute: typeof AppPedidosIndexRoute
  AppReportesIndexRoute: typeof AppReportesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppConfiguracionPedidosRoute: AppConfiguracionPedidosRoute,
  AppIndexRoute: AppIndexRoute,
  AppCalendarioEventoIdRoute: AppCalendarioEventoIdRoute,
  AppCalendarioNuevoRoute: AppCalendarioNuevoRoute,
  AppGastosGastoIdRoute: AppGastosGastoIdRoute,
  AppGastosNuevoRoute: AppGastosNuevoRoute,
  AppPedidosPedidoIdRoute: AppPedidosPedidoIdRoute,
  AppPedidosNuevoRoute: AppPedidosNuevoRoute,
  AppCalendarioIndexRoute: AppCalendarioIndexRoute,
  AppExportarIndexRoute: AppExportarIndexRoute,
  AppGastosIndexRoute: AppGastosIndexRoute,
  AppInventarioIndexRoute: AppInventarioIndexRoute,
  AppPedidosIndexRoute: AppPedidosIndexRoute,
  AppReportesIndexRoute: AppReportesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  OrdenarRoute: OrdenarRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
